import React, { useEffect, useState, useCallback } from "react";
import {
    Box,
    Button,
    CircularProgress,
} from "@mui/material";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import TimelineIcon from '@mui/icons-material/Timeline';
import { get, post } from "../../services/api-services";
import EnrollProgramDialog from "../../component/Case-Detail/profileModel-DialogBox/AddEnrollProgramDialog";
import Measurement from "../../component/Case-Detail/profileModel/Measurement";
import Programs from "../../component/Case-Detail/profileModel/Programs";
import GeneralInfo from "../../component/Case-Detail/profileModel/GeneralInfo";
import Timeline from "../../component/Case-Detail/ViewTimeLine/TimeLine";
import HealthMetrics from "../../component/Case-Detail/profileModel/HealthMetrics";

import PersonIcon from '@mui/icons-material/Person';
import { StyledBlueButton, StyledTab } from "../../component/StyledComponent";
import Tabs from '@mui/material/Tabs';

import InfoIcon from '@mui/icons-material/Info';
import StraightenIcon from '@mui/icons-material/Straighten';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ModuleHeading from "../../component/ModuleHeading";
import { useCommon } from "../../context/CommonContext";

const TAB_SECTIONS = ["generalInfo", "measurement", "programs", "healthMetrics"];

const CaseDetails = () => {
    const [userData, setUserData] = useState({});
    const [userEnrollment, setUserEnrollment] = useState([]);
    const [loading, setLoading] = useState(true);
    const { setSnackbar } = useCommon();
    const { id } = useParams();
    const location = useLocation();
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [showTimeline, setShowTimeline] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    // Persist active tab in URL query params so it survives refresh
    const [searchParams, setSearchParams] = useSearchParams();
    const initialTab = parseInt(searchParams.get('tab') || '0', 10);
    const [value, setValue] = useState(initialTab);
    const [activeSection, setActiveSection] = useState(TAB_SECTIONS[initialTab] || "generalInfo");

    const handleChange = (event, newValue) => { setValue(newValue); };
    const [allPrograms, setAllPrograms] = useState([]);
    const [tax, setTax] = useState([]);

    const onGetPrograms = useCallback(async () => {
        const res = await get('/Programs');
        if (res?.statusCode === 200) {
            setAllPrograms(res?.data)
        }
    }, [setAllPrograms])
    const onGetTex = useCallback(async () => {
        const res = await get('/Settings?filter={"where" : {"taxType" : "GST"}}');
        if (res?.statusCode === 200) {
            setTax(res?.data[0]?.taxValue);
        }
    }, [setTax])

    const onEnrollProgram = useCallback(async ({ program, programDate, paymentDueDate, discount, discountNote }) => {
        try {
            const res = await get('/Invoices?filter={"order" : "createdAt DESC", "limit" : "1" }');
            if (res?.statusCode === 200) {
                let invoice_id = 1
                const lastInvoice = res?.data;
                if (lastInvoice?.length > 0) {
                    if (lastInvoice[0].invoiceID && lastInvoice[0].invoiceID !== '') {
                        invoice_id = lastInvoice[0].invoiceID + 1;
                    }
                }
                let status = '';
                if (discount === program?.price) {
                    status = 'Paid';
                } else {
                    status = 'Due';
                }
                let data = { invoiceID: invoice_id, programId: program?.id, purchaseProgram: program, tax: tax, enrollOn: programDate, dueDate: paymentDueDate, feeDiscount: discount, discountNote: discountNote, status: status, createdAt: new Date(), updatedAt: new Date() };
                const postRes = await post('/Invoices', data);
                if (postRes?.statusCode === 200) {
                    let date = new Date();
                    let last = new Date(date.getTime() + (program?.duration * 24 * 60 * 60 * 1000));
                    let userProgramData = {
                        invoiceId: postRes?.data?.id, customerId: id, programId: postRes?.data?.programId,
                        status: 'active', createdAt: new Date(), updatedAt: new Date(), dueAmount: postRes?.data?.purchaseProgram?.price, day: 1, endDate: last
                    };
                    const userProgram = await post('/UserPrograms', userProgramData);
                    if (userProgram?.statusCode === 200) {
                        setSnackbar({
                            openSnackbar: true,
                            message: 'Program enrolled successfully!',
                            severity: 'success'
                        })
                        // Refresh user data & enrollment after successful enrollment
                        fetchUserData();
                        setRefreshTrigger(prev => prev + 1);
                    }
                }
            }
        } catch (error) {
            // Error handled by common context or silently
        }
    }, [id, setSnackbar, tax])

    // Fetch user data on component mount
    const fetchUserData = useCallback(async () => {

        try {
            const response = await get(`/Customers/${id}`);
            setUserData(response?.data);

            setLoading(false);
            const enrollmentRes = await get(
                `/UserPrograms?filter=${encodeURIComponent(JSON.stringify({
                    where: { customerId: id },
                    include: "invoice",
                    order: "createdAt DESC"
                }))}`
            );

            if (enrollmentRes?.statusCode === 200) {
                setUserEnrollment(enrollmentRes?.data)
            }
        } catch (error) {
            console.error("Error fetching data", error);
            setSnackbar({
                openSnackbar: true,
                message: "Failed to load case data",
                severity: 'error'
            })
            setLoading(false);
        }
    }, [id, setSnackbar]);


    useEffect(() => {
        fetchUserData();
        // fetchPayments();
    }, [fetchUserData]);


    useEffect(() => {
        onGetTex()
        onGetPrograms();
    }, [onGetTex, onGetPrograms])
    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
                <CircularProgress />
            </Box>
        );
    }
    const handleEnrolltoProgram = () => {
        // Refresh programs list before opening dialog to ensure latest are available
        onGetPrograms();
        setIsDialogOpen(true);
    };
    const handleDialogClose = () => setIsDialogOpen(false);
    const handleSectionChange = (section, newValue) => { 
        setActiveSection(section); 
        setValue(newValue);
        // Persist tab index in URL so it survives page refresh
        setSearchParams(newValue === 0 ? {} : { tab: String(newValue) }, { replace: true, state: location.state });
        // Only fetch on initial load, not on every tab switch (each tab manages its own data)
    }

    const handleViewTimeline = () => {
        setShowTimeline((prev) => !prev);
    };

    return (
        <div className='flex-1 flex flex-col gap-3'>

            {/* Top Section */}
            <div className="flex flex-col md:justify-between md:items-center md:flex-row">
                {/* Left Side - Back Button and Title */}
                <ModuleHeading title="Case Detail " navigateTo="/admin/cases" />
                {/* Right Side - Buttons */}
                <Box display="flex" gap={2}>
                    <Button
                        variant={showTimeline ? "contained" : "text"}
                        onClick={handleViewTimeline}
                        startIcon={showTimeline ? <PersonIcon /> : <TimelineIcon />}
                        sx={{
                            textTransform: 'none',
                            color: showTimeline ? '#3c50b4' : '#3c50b4',
                            fontWeight: 'bold',
                            backgroundColor: showTimeline ? '#c5cae9' : 'transparent',
                            '&:hover': {
                                backgroundColor: '#c5cae9'
                            },
                        }}
                    >
                        {showTimeline ? "View Profile" : "View Timeline"}
                    </Button>


                    <StyledBlueButton variant="contained" onClick={handleEnrolltoProgram}>
                        Enroll to program
                    </StyledBlueButton>
                </Box>

            </div>

            {!showTimeline ? (
                <>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="wrapped label tabs example"
                        scrollButtons="auto" variant="scrollable"
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "transparent",
                                indicatorColor: "#3c50b4",
                                color: "#3c50b4"
                            }
                        }}
                    >
                        <StyledTab
                            icon={<InfoIcon sx={{ fontSize: '18px' }} />}
                            iconPosition="start"
                            style={{
                                borderBottom: value === 0 ? "2px solid #3c50b4" : "2px solid #A9ABB5",
                                minHeight: '48px'
                            }}
                            value={0} label="General Info" onClick={() => handleSectionChange("generalInfo", 0)} />
                        <StyledTab
                            icon={<StraightenIcon sx={{ fontSize: '18px' }} />}
                            iconPosition="start"
                            style={{ borderBottom: value === 1 ? "2px solid #3c50b4" : "2px solid #A9ABB5", minHeight: '48px' }}
                            value={1} label="Measurements" onClick={() => handleSectionChange("measurement", 1)} />
                        <StyledTab
                            icon={<AssignmentIcon sx={{ fontSize: '18px' }} />}
                            iconPosition="start"
                            style={{ borderBottom: value === 2 ? "2px solid #3c50b4" : "2px solid #A9ABB5", minHeight: '48px' }}
                            value={2} label="Programs" onClick={() => handleSectionChange("programs", 2)} />
                        <StyledTab
                            icon={<AssignmentIcon sx={{ fontSize: '18px' }} />}
                            iconPosition="start"
                            style={{ borderBottom: value === 3 ? "2px solid #3c50b4" : "2px solid #A9ABB5", minHeight: '48px' }}
                            value={3} label="Health Metrics" onClick={() => handleSectionChange("healthMetrics", 3)} />
                    </Tabs>
                    {/* Conditional Rendering of Sections */}
                    {activeSection === "generalInfo" && <GeneralInfo userData={userData} fetchUserData={fetchUserData} userEnrollment={userEnrollment} handleSectionChange={handleSectionChange} />}
                    {activeSection === "measurement" && <Measurement userData={userData} fetchUserData={fetchUserData} />}
                    {activeSection === "programs" && <Programs refreshTrigger={refreshTrigger} />}
                    {activeSection === "healthMetrics" && <HealthMetrics userId={id} userData={userData} />}
                </>
            ) : (

                <Timeline userData={userData} />
            )}
            <EnrollProgramDialog
                open={isDialogOpen}
                onClose={handleDialogClose}
                allPrograms={allPrograms}
                onSubmit={onEnrollProgram}
            />



        </div>
    );
};

export default CaseDetails;


